var _path, _rect, _circle, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApprovedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 112C86.928 112 112 86.928 112 56C112 25.0721 86.928 0 56 0C25.0721 0 0 25.0721 0 56C0 86.928 25.0721 112 56 112Z",
    fill: "#EDF7F0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.9,
    x: 31,
    y: 30.9998,
    width: 50,
    height: 50,
    rx: 19,
    fill: "url(#paint0_linear)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56.0002,
    cy: 55.9999,
    r: 9.75406,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.92,
    d: "M52.146 56.3671L54.4946 58.7157L54.4794 58.7005L59.778 53.4019",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1769 34.0074C30.7551 34.0074 32.0345 32.728 32.0345 31.1498C32.0345 29.5716 30.7551 28.2922 29.1769 28.2922C27.5987 28.2922 26.3193 29.5716 26.3193 31.1498C26.3193 32.728 27.5987 34.0074 29.1769 34.0074Z",
    fill: "url(#paint1_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5118 92.089C68.7145 92.089 69.6895 91.1139 69.6895 89.9112C69.6895 88.7084 68.7145 87.7334 67.5118 87.7334C66.309 87.7334 65.334 88.7084 65.334 89.9112C65.334 91.1139 66.309 92.089 67.5118 92.089Z",
    fill: "url(#paint2_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8518 39.3701C80.5495 39.3701 81.9257 37.9938 81.9257 36.2961C81.9257 34.5984 80.5495 33.2222 78.8518 33.2222C77.1541 33.2222 75.7778 34.5984 75.7778 36.2961C75.7778 37.9938 77.1541 39.3701 78.8518 39.3701Z",
    fill: "url(#paint3_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.936 54.1753C17.9395 54.1753 18.7529 53.3619 18.7529 52.3584C18.7529 51.355 17.9395 50.5415 16.936 50.5415C15.9326 50.5415 15.1191 51.355 15.1191 52.3584C15.1191 53.3619 15.9326 54.1753 16.936 54.1753Z",
    fill: "url(#paint4_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0444 21.1988C52.431 21.1988 53.5551 20.0748 53.5551 18.6882C53.5551 17.3016 52.431 16.1775 51.0444 16.1775C49.6578 16.1775 48.5337 17.3016 48.5337 18.6882C48.5337 20.0748 49.6578 21.1988 51.0444 21.1988Z",
    fill: "url(#paint5_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6889 66.5672C97.1855 66.5672 98.3988 65.354 98.3988 63.8574C98.3988 62.3607 97.1855 61.1475 95.6889 61.1475C94.1923 61.1475 92.979 62.3607 92.979 63.8574C92.979 65.354 94.1923 66.5672 95.6889 66.5672Z",
    fill: "url(#paint6_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37 80.9998C39.7614 80.9998 42 78.7612 42 75.9998C42 73.2384 39.7614 70.9998 37 70.9998C34.2386 70.9998 32 73.2384 32 75.9998C32 78.7612 34.2386 80.9998 37 80.9998Z",
    fill: "url(#paint7_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 56,
    y1: 30.9998,
    x2: 56.3252,
    y2: 77.1504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008E5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BD0B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 29.1769,
    y1: 28.2922,
    x2: 29.1769,
    y2: 34.0074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BD0B0",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2F4EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 67.5118,
    y1: 87.7334,
    x2: 67.5118,
    y2: 92.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BD0B0",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2F4EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 78.8518,
    y1: 33.2222,
    x2: 78.8518,
    y2: 39.3701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BD0B0",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2F4EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 16.936,
    y1: 50.5415,
    x2: 16.936,
    y2: 54.1753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BD0B0",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2F4EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 51.0444,
    y1: 16.1775,
    x2: 51.0444,
    y2: 21.1988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BD0B0",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2F4EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 95.6889,
    y1: 61.1475,
    x2: 95.6889,
    y2: 66.5672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BD0B0",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2F4EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 37,
    y1: 70.9998,
    x2: 37,
    y2: 80.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BD0B0",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2F4EC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovedIcon);
export default __webpack_public_path__ + "static/media/approved-icon.3ae6fbef8370a83b53afc4414a88b57f.svg";
export { ForwardRef as ReactComponent };